import Paper from '@material-ui/core/Paper';
import TextField from '@material-ui/core/TextField';
import React from 'react';
import { defineMessages, FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import SecondaryRaisedButton from '../buttons/SecondaryRaisedButton';
import Heading from '../heading/Heading';
import Link from '../InternalLink';
import { media } from '../styles/breakpoints';
import CountrySelection from './CountrySelection';

defineMessages({
    labelMail: {
        id: 'LABEL_FORMFIELD_EMAIL',
        defaultMessage: 'E-Mail-Adresse',
    },
    labelMail: {
        id: 'LABEL_FORMFIELD_EMAIL_REQUIRED',
        defaultMessage: 'Die E-Mail-Adresse brauchen wir dafür.',
    },
    labelStrasse: {
        id: 'LABEL_FORMFIELD_STRASSE',
        defaultMessage: 'Strasse & Hausnummer',
    },
    labelCity: {
        id: 'LABEL_FORMFIELD_CITY',
        defaultMessage: 'Stadt',
    },
    labelFirstName: {
        id: 'LABEL_FORMFIELD_FIRSTNAME',
        defaultMessage: 'Vorname',
    },
    labelLastName: {
        id: 'LABEL_FORMFIELD_LASTNAME',
        defaultMessage: 'NACHNAME',
    },
    labelAddress2: {
        id: 'LABEL_FORMFIELD_ADDRESS',
        defaultMessage: 'Adresszusatz',
    },
    labelZip: {
        id: 'LABEL_FORMFIELD_ZIP',
        defaultMessage: 'Postleitzahl',
    },
    labelState: {
        id: 'LABEL_FORMFIELD_STATE',
        defaultMessage: 'State/Province/Region/Kanton',
    },
    labelHelpState: {
        id: 'LABEL_FORMFIELD_HELP_STATE',
        defaultMessage: 'Nur, wenn es für die Sendungszustellung wichtig ist.',
    },
    helpTextNewsletterMailOnly: {
        id: 'NEWSLETTER_FORM_HELPTEXT_MAILONLY',
        defaultMessage: 'Kurze Anleitung und regelmäßig Design Trends in Deine Mailbox sowie ein Stoffmuster in den Briefkasten. Dafür brauchen wir Deine E-Mail-Adresse.',
    },
    newsLetterText: {
        id: 'NEWSLETTER_BAR_TEXT',
        defaultMessage: 'Unser Newsletter hilft Dir mit den Möglichkeiten der Stoffgestaltung anhand von praktischen Beispielen und einem echten Stoffstück in Deinen Händen.',
    },
    newsLetterTitle: {
        id: 'NEWSLETTER_BAR_TITLE',
        defaultMessage: 'Stoffmuster, Farbkarte und Newsletter.',
    },
    newsLetterButtonTitle: {
        id: 'LABEL_NEWSLETTER_BAR_BUTTON',
        defaultMessage: 'Will ich haben',
    },
});

const ChildWrapper = styled.div`
    display: flex;
    flex-direction: column;
    padding: ${props => props.theme.space[3]};
    margin-top:  ${props => props.theme.space[5]};
    max-width: 19rem;
    flex-grow: 1;
`;

const FabricSelectionWrapper = styled(Paper)`
    padding: ${props => props.theme.space[8]};
    margin-right:  ${props => props.theme.space[9]};
    margin-top:  ${props => props.theme.space[9]};
    &.stolo-newsletter-bar {
    
    }
    
`;

const StyledhtmlFormWrapper = styled(Paper)`
    max-width: 70ch;
    margin:  ${props => props.theme.space[6]} auto;
    padding: ${props => props.theme.space[9]};
    overflow: hidden;

    & img {
       height: auto;
          width: auto;
          max-width: 100%;
    }
`;

const StyledTextInput = styled(TextField)`
    display: block;
    margin: ${props => props.theme.space[3]} 0;
    width: 100%;
    max-width: ${props => props.theme.space[22]};
    color: greenyellow;
    
    &.newsletter-zip {
      margin-right: ${props => props.theme.space[9]};
      max-width: ${props => props.theme.space[16]};
    }
    
    & .newsletter-fullwidth {
      width: 100%;
    }
`;

const StyledSelection = styled.div`
    margin: ${props => props.theme.space[3]} ${props => props.theme.space[9]} ${
    props => props.theme.space[3]} 0;
    width: ${props => props.theme.space[20]};
`;

const StyledFormAddressText = styled.p`
    margin: ${props => props.theme.space[12]} 0 ${props => props.theme.space[4]};
    max-width: ${props => props.theme.space[23]};
`;

const StyledFormText = styled.p`
    margin: 0 0 ${props => props.theme.space[4]};
    
    & .stolo-form-text {
      max-width: ${props => props.theme.space[22]};
    }
    
`;

const ResponsiveInputGroup = styled.div`
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    justify-content: flex-start;
    max-width: ${props => props.theme.space[22]};
    
    ${media.tweak700up`
        flex-direction: column;
    `};
    
`;


class NewsletterhtmlForm extends React.Component {
    handleSubmit = () => {
        console.log('mailchimp subscribed');
    };

    state = {
        render: false,
    };

    componentDidMount() {
        // Quick fix for wrong loading css/material ui stuff.
        // @ToDo Proper fix this.
        this.setState({ render: true });
    }

    render() {
        return (
            this.state.render === false ?
                <div>...Loading</div>
                :
                <StyledhtmlFormWrapper>
                    <Heading
                        level={2} text={<FormattedMessage
                            id='NEWSLETTER_SUBSCRIBE_PAGE_TITLE'
                            defaultMessage='Newsletter & Farbkarte'
                        />}
                    />
                    <StyledFormText>
                        <FormattedMessage
                            className='stolo-form-text'
                            id='NEWSLETTER_SUBSCRIBE_PAGE_TEXT'
                            defaultMessage='Jetzt schnell eintragen und eine Mini-Farbkarte mitnehmen. Der Newsletter zeigt Dir regelmässig die schönste Stoff- und Schnittauswahl von www.stoff.love und www.schnoffle.de. Du kannst den Newsletter jederzeit abbestellen. Lies auch
                            unsere {privacy}.'
                            values={{
                                privacy: (
                                    <Link
                                        to={'/legal/privacy'}
                                    ><FormattedMessage
                                        id={'PRIVACY_LABEL'}
                                        defaultMessage='Datenschutzerklärung'
                                    /></Link>
                                ),
                            }}
                        />
                    </StyledFormText>

                    <div>
                        <form
                            action='//love.us12.list-manage.com/subscribe/post?u=dc31cc40dd1d2a16ee1f637d1&amp;id=c2a04ff697'
                            method='post'
                            id='mc-embedded-subscribe-form'

                            className='validate'
                            target='_blank' noValidate
                        >
                            <StyledTextInput
                                label='E-Mail-Adresse'
                                id='mce-EMAIL'
                                name='EMAIL'
                                helperText='Die E-Mail Adresse brauchen wir.'
                                placeholder='E-Mail-Adresse'
                                required
                                type='email'
                                inputProps={{ className: 'newsletter-fullwidth' }}
                            />
                            <StyledFormAddressText>
                                <FormattedMessage
                                    id='NEWSLETTER_SUBSCRIBE_PAGE_WHY_ADDRESS'
                                    defaultMessage='Deine Adresse benötigen wir nur, wenn Du eine Gratis-Farbkarte möchtest.'
                                />
                            </StyledFormAddressText>

                            <StyledTextInput
                                label='Vorname'
                                id='mce-FNAME'
                                name='FNAME'
                                placeholder='Vorname'
                                inputProps={{ className: 'newsletter-fullwidth' }}
                            />
                            <StyledTextInput
                                label='Nachname'
                                id='mce-LNAME'
                                name='LNAME'
                                placeholder='Nachname'
                                inputProps={{ className: 'newsletter-fullwidth' }}
                            />

                            <StyledTextInput
                                label='Strasse & Hausnummer'
                                id='mce-MMERGE3-addr1'
                                name='MMERGE3[addr1]'
                                placeholder='Strasse & Hausnummer'
                                maxLength='70'
                                inputProps={{ className: 'newsletter-fullwidth' }}
                            />
                            <StyledTextInput
                                label='Adresszusatz'
                                name='MMERGE3[addr2]'
                                id='mce-MMERGE3-addr2'
                                placeholder='Adresszusatz'
                                maxLength='70'
                                inputProps={{ className: 'newsletter-fullwidth' }}
                            />
                            <ResponsiveInputGroup>
                                <StyledTextInput
                                    inputProps={{ className: 'newsletter-zip' }}
                                    className='newsletter-zip'
                                    label='Postleitzahl'
                                    name='MMERGE3[zip]'
                                    id='mce-MMERGE3-zip'
                                    placeholder='Postleitzahl'
                                    maxLength='10'
                                />
                                <StyledTextInput
                                    label='Stadt'
                                    name='MMERGE3[city]'
                                    id='mce-MMERGE3-city'
                                    placeholder='Stadt'
                                    maxLength='40'
                                    inputProps={{ className: 'newsletter-fullwidth' }}
                                />
                            </ResponsiveInputGroup>
                            <ResponsiveInputGroup>
                                <StyledSelection>
                                    <CountrySelection />
                                </StyledSelection>

                                <StyledTextInput
                                    label='State/Province/Region/Kanton'
                                    name='MMERGE3[state]'
                                    id='mce-MMERGE3-state'
                                    placeholder='State/Province/Region/Kanton'
                                    maxLength='40'
                                    helperText='Nur, wenn das für die Postzustellung wichtig ist.'
                                    inputProps={{ className: 'newsletter-fullwidth' }}
                                />
                            </ResponsiveInputGroup>
                            <div id='mce-responses' className='clear'>
                                <div
                                    className='response' id='mce-error-response'
                                    style={{ display: 'none' }}
                                />
                                <div
                                    className='response'
                                    id='mce-success-response'
                                    style={{ display: 'none' }}
                                />
                            </div>

                            <div
                                className='hidden'
                                style={{
                                    position: 'absolute',
                                    left: '-5000px',
                                }}
                            >
                                <input
                                    type='text'
                                    name='b_dc31cc40dd1d2a16ee1f637d1_c2a04ff697'
                                    tabIndex='-1' value=''
                                />
                            </div>

                            <SecondaryRaisedButton
                                onSubmit={this.handleSubmit()}
                                type='submit'
                                name='subscribe'
                                id='mc-embedded-subscribe'
                                disabled={false}
                                icon='gift'
                                text={<FormattedMessage
                                    id='LABEL_NEWSLETTER_BUTTON'
                                    defaultMessage='Eintragen und Gratis-Griffmuster mitnehmen'
                                />}
                            />

                        </form>
                    </div>
                </StyledhtmlFormWrapper>
        );
    }
}


export default NewsletterhtmlForm;



// WEBPACK FOOTER //
// ./src/components/newsletter/NewsletterForm.js